import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import SiteHeader from "@/components/site/SiteHeader";
import Hero from "@/components/site/Hero";
import MenuSection from "@/components/site/MenuSection";
import StorySection from "@/components/site/StorySection";
import GallerySection from "@/components/site/GallerySection";
import ContactSection from "@/components/site/ContactSection";
import SiteFooter from "@/components/site/SiteFooter";

export default function HomePage() {
    const { lang } = useI18n();
    const [content, setContent] = useState(null);
    const [menu, setMenu] = useState([]);
    const [categories, setCategories] = useState([]);
    const [gallery, setGallery] = useState([]);

    useEffect(() => {
        Promise.all([
            api.get("/content"),
            api.get("/menu"),
            api.get("/categories"),
            api.get("/gallery"),
        ])
            .then(([c, m, cat, g]) => {
                setContent(c.data);
                setMenu(m.data);
                setCategories(cat.data);
                setGallery(g.data);
            })
            .catch(() => {});
    }, []);

    const seoTitle = lang === "es"
        ? "Cuba Bella Café — Auténtica Cocina Cubana en Dallas"
        : "Cuba Bella Café — Authentic Cuban Cuisine in Dallas";
    const seoDesc = lang === "es"
        ? "Café cubano auténtico, Ropa Vieja, Sándwich Cubano y mojitos en Dallas. Llama al +1 (972) 710-3322."
        : "Authentic Cuban coffee, Ropa Vieja, Cuban Sandwich and mojitos in Dallas. Call +1 (972) 710-3322.";

    return (
        <div className="App film-grain">
            <Helmet>
                <html lang={lang} />
                <title>{seoTitle}</title>
                <meta name="description" content={seoDesc} />
                <meta property="og:title" content={seoTitle} />
                <meta property="og:description" content={seoDesc} />
                {content?.logo_url && <meta property="og:image" content={content.logo_url} />}
            </Helmet>
            <SiteHeader logoUrl={content?.logo_url} phone={content?.phone} />
            <Hero content={content || {}} />
            <MenuSection categories={categories} items={menu} />
            <StorySection content={content || {}} />
            <GallerySection images={gallery} />
            <ContactSection content={content || {}} />
            <SiteFooter content={content || {}} />
        </div>
    );
}
